import * as React from 'react';
import chroma from 'chroma-js';

const Bos = ({ mainColor, secColor }) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 351.21 351.21"
      height={200}
      width={200}
    >
      <defs>
        <mask id="maskRounded">
          <rect width="100%" height="100%" rx="20" ry="20" fill="white" />
        </mask>
        <radialGradient
          id="Gradient1"
          cx="301.71"
          cy="309.46"
          r="174.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={mainColor} stopOpacity="0.7" />
          <stop offset="0.8" stopColor={mainColor + '00'} stopOpacity="0" />
          <stop offset="1" stopColor={'#fff'} stopOpacity="0" />
        </radialGradient>

        <radialGradient
          id="Gradient2"
          cx="124.2"
          cy="371.39"
          r="184.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={secColor} stopOpacity="0.7" />
          <stop offset="0.8" stopColor={secColor + '00'} stopOpacity="0" />
          <stop offset="1" stopColor={'#fff'} stopOpacity="0" />
        </radialGradient>
      </defs>
      <g mask="url(#maskRounded)">
        <g>
          <rect fill="#f7f7f7" x={-34.88} y={-31.44} width={418} height={418} />
          <circle cx={301.71} cy={309.46} r={154.24} fill="url(#Gradient1)" />
          <rect
            fill="#FFF"
            x={29.47}
            y={29.02}
            width={226.09}
            height={175.36}
            rx={13.33}
            ry={13.33}
          />
          <path
            fill="#eaeaea"
            d="M29.47,52.43h65.22v151.95h-51.91c-7.34,0-13.31-5.96-13.31-13.31V52.43h0Z"
          />
          <circle className="cls-5" cx={41.68} cy={41.52} r={2.54} />
          <circle className="cls-8" cx={50.66} cy={41.52} r={2.54} />
          <circle className="cls-10" cx={59.54} cy={41.52} r={2.54} />
          <circle fill="#FFFFFF00" cx={124.2} cy={371.39} r={154.24} />
        </g>
        <circle cx={124.2} cy={371.39} r={154.24} fill="url(#Gradient2)" />
        <circle fill={mainColor} cx={97.13} cy={216.79} r={39.24} />
        <rect
          fill="#FFF"
          x={90.66}
          y={194.95}
          width={27.76}
          height={27.76}
          rx={13.88}
          opacity={0.69}
          ry={13.88}
          transform="translate(-104.3 313.37) rotate(-90)"
        />
        <path
          fill="#FFF"
          d="M78.25,218.58c6.13-2.9,12.27-5.81,18.4-8.71,2.81-1.33,6.04.73,6.02,3.83l-.1,20.72c-.02,3.35-3.74,5.34-6.53,3.51l-18.3-12.01c-2.75-1.81-2.47-5.93.51-7.34Z"
        />
      </g>
    </svg>
  );
};
export default Bos;
